import * as React from "react";
import { Props } from "../../types/global";
import Number from "../topup/Number";
import { Country, AutoProfile, Product, CreditCardPayment, CreditCard, StoredCreditCard, PaymentCountry, SiteSettings, Sku, UserBrowserInfo } from "../types";
import { MyAccountService } from "./myaccount-service";
import CreditCardComp from "../common/CreditCard";
import { isDev, uuidv4, isMobileNumberValid, validateStoredCard, formatDate } from "../utils";
import { CatalogService } from "../services/catalog-service";
import { CreditCardFactory, ICreditCard } from "../common/credit-card-factory";
import classNames from "classnames";
import { StoredCreditCardComp } from "../common/StoredCreditCard";
import { FingerprintFactory, IFingerprint } from "../common/finger-print-factory";
import { TopupService } from "../services/topup-service";
import { dialogService } from "react-api-dialog";
import ThreeDSecure from "../common/3DSeccure";
import { Loading } from "../common/Loading";
import { Footer } from "./Footer";
import { Frequency } from "../types-enums";
import { weekDays, biWeekDays, monthDays, nextTopupDate, humanizeDay } from "../services/date-time-service";
import { messageDialog } from "../dialogs/MessageDialog";
import t from "../i18n";
import MaskedInput from 'react-text-mask';

declare type AutoTopupQuery = {
    cc: string,
    mn: string,
    a: string,
    p: string
}
declare type AutoTopupState = {
    countries: Country[],
    selectedCountry?: Country,
    products: Product[],
    profile: AutoProfile,
    payment: CreditCardPayment
    storedCreditCards: StoredCreditCard[],
    paymentCountries: PaymentCountry[],
    addressSettings?: { usUkCa: boolean, others: boolean },
    siteSettings?: SiteSettings,
    creditCardHelper?: ICreditCard,
    fingerPrintHelpers: IFingerprint[],
    sessionId: string,
    showFooter: boolean,
    isDataPlan:boolean,
    category:number
}
const contactMask = [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,/\d/,/\d/,/\d/,/\d/];
export default class AutoTopup extends React.Component<Props<undefined, AutoTopupQuery>, AutoTopupState> {
    readonly state: AutoTopupState = {
        countries: [],
        products: [],
        sessionId: uuidv4(),
        profile: {
            frequency: Frequency.Monthly,
            topupDay: 1
        } as AutoProfile,
        payment: { creditCardMethod: "new", creditCard: creditCardDev },
        storedCreditCards: [],
        paymentCountries: [],
        fingerPrintHelpers: [],
        showFooter: true,
        isDataPlan:false,
        category:1
    };
    private _maskRef: HTMLInputElement | null;
    assignMaskRef = (element: MaskedInput | null) => {
        if (element) {
            // tslint:disable-next-line:no-string-literal
            // @ts-ignore
            this._maskRef = element["inputElement"];
            this._maskRef!.focus();
        } else {
            element = null;
        }
    }
    _creditCardComp: CreditCardComp | null;
    onMobileNumberChanged = (mobileNumber: string) => {
        this.setState({
            profile: {
                ...this.state.profile,
                localMobileNumber: mobileNumber
            }
        })
    }
    onCountrySelected = async (country: Country) => {
        this.setState({
            selectedCountry: country, profile: {
                ...this.state.profile,
                internationalCode: country.internationalCode,
                countryCode: country.countryCode,
                productId: undefined
            }
        });
        dialogService.showPreloader();
        const response = await MyAccountService.getProducts(country.countryCode);
        await dialogService.hidePreloader();
        if (response.responseCode === 0) {
            const productsAll = response.payLoad!.products;
            // show only products which have Topup SKUs. Exclude Products with only Data SKUs like Jio India.
            const products = productsAll.filter(p => p.skus.length > 0);
            if (products.length === 1) {
                const sku = products[0].skus[0];
                this.setState({ products: products, profile: { ...this.state.profile, productId: products[0].productId, skuId: sku.skuId } })
            } else {
                this.setState({ products: products, profile: { ...this.state.profile, productId: undefined, skuId: undefined } })
            }
        }
    }
    onProductSelected = (productId: number) => {   
        const product = this.state.products.find(p => p.productId === productId);
        if (!product) return;
        let sku:any;
        if(this.state.isDataPlan)
            sku = product.skus[0];
        else
            sku=product.skus[1];
        this.setState({ profile: { ...this.state.profile, productId: productId, skuId: sku.skuId } })
    }
    
    onCategoryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ profile: { ...this.state.profile, category: +e.target.value} });
        if(e.target.value=="2") 
            this.state.isDataPlan=true;
        else
            this.state.isDataPlan=false;
        this.onProductSelected(this.state.profile.productId||0);
    }

    onFrequencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ profile: { ...this.state.profile, frequency: +e.target.value, topupDay: 1 } });
    }
    onTopupDayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ profile: { ...this.state.profile, topupDay: +e.target.value } });
    }
    onContactNumberChange = (value: any) => {
        this.setState({ profile: { ...this.state.profile, contactNumber: value } });
    }
    formatMessage = (frequency: Frequency, topupDay: number) => {
        const startDate = nextTopupDate(frequency, topupDay, this.state.siteSettings ? this.state.siteSettings.holdingPeriod : 2);
        const startDateFormated = formatDate(startDate);
        const freq = frequency === Frequency.Weekly ? t.autoTopup("week") : frequency === Frequency.BiWeekly ? t.autoTopup("frequency_15days") : t.autoTopup("month");
        const topupDayString = humanizeDay(topupDay, frequency);
        const message = t.autoTopup("schedule", {
            freq, topupDayString, startDateFormated
        });
        //const message =!this.state.isDataPlan?t.autoTopup("schedule", {freq, topupDayString, startDateFormated}) :t.autoTopup("schedule_data", {freq, topupDayString, startDateFormated});
        if (this.state.profile && this.state.profile.productId) {
            const selectedProduct = this.state.products.find(p => p.productId === this.state.profile.productId);
            if (selectedProduct) {
                const sku = selectedProduct.skus[0];
                if (sku.usdFaceValue) {
                    return <>
                        {message}
                        <br /> <br />
                        {this.state.siteSettings && this.state.siteSettings.autoTopupMultiCurrencyMessage}
                    </>
                }
            }
        }
        return message;
    }
    creditCardMethodChanged = (value: "new" | "stored") => {
        this.setState({ payment: { ...this.state.payment, creditCardMethod: value } });
    }
    creditCardChanged = (newCard: CreditCard) => {
        this.setState({
            payment: {
                ...this.state.payment,
                creditCard: newCard
            }
        });
    }
    storedCreditCardChanged = (storedCard: StoredCreditCard) => {
        this.setState({
            payment: {
                ...this.state.payment,
                storedCard: storedCard
            }
        });
    }
    loadCreditCardDetails = async (sourceCurrencyCode: string) => {
        const response = await CatalogService.fetchCardsAndCounties(this.state.sessionId, sourceCurrencyCode);
        // if (!response || response.responseCode !== 0) {
        //     return undefined;
        // };
        const { cards: storedCreditCards, countries, addressSettings, creditCardSettings, siteSettings } = response.payLoad;
        const creditCardHelper = CreditCardFactory.getHelper(creditCardSettings);
        return {
            storedCreditCards: storedCreditCards,
            paymentCountries: countries,
            addressSettings: addressSettings,
            siteSettings: siteSettings,
            creditCardHelper
        };
    }
    submit = () => {
        const isCountryValid = !!this.state.selectedCountry;
        if (isCountryValid === false) {
            messageDialog(t.topup("select_country"), t.menu("auto_balance"));
            return;
        }
        const product = this.state.products.find(p => p.productId === this.state.profile.productId);
        const mobileNumberError = isMobileNumberValid(this.state.selectedCountry, product, this.state.profile.localMobileNumber) ? undefined : t.error("error_mobile_number");
        const operatorError = this.state.profile.productId ? undefined : t.topup("select_operator");
        const skuError = this.state.profile.skuId ? undefined : t.topup("amount_missing");
        const contactError = this.state.profile.contactNumber ? undefined : t.autoTopup("contact_number_missing");
        const creditCardError = this.state.payment.creditCardMethod === "new" && !this._creditCardComp!.validate() ? t.error("error_credit_card") : undefined;
        const storedCardError = this.state.payment.creditCardMethod === "stored" && validateStoredCard(this.state.payment.storedCard);
        const error = mobileNumberError || operatorError || skuError || creditCardError || storedCardError || contactError;
        if (error) {
            messageDialog(error, t.common("oops"));
            return;
        } else {
            this.processCreditCard();
        }
    }
    processCreditCard = async () => {
        const isNewCard = this.state.payment.creditCardMethod === "new";
        let newCCInfo: CreditCard | undefined;
        const creditCard = this.state.payment.creditCard;
        if (isNewCard) {
            if (!creditCard) return;
            const creditCardNumber = creditCard.creditCardNumber.replace(/ /g, "");
            const token = await this.state.creditCardHelper!.tokenize(creditCard);
            newCCInfo = { ...creditCard, creditCardNumber, creditCardToken: token };
        }
        dialogService.showPreloader();
        const storedCard = this.state.payment.storedCard!;
        var date = new Date(); 
        var browserInfo : UserBrowserInfo = { screenHeight : screen.height || undefined, screenColorDepth : screen.colorDepth || undefined, screenWidth : screen.width || undefined, timezone : date.getTimezoneOffset() || undefined, language : navigator.language || "", isJavaEnabled : navigator.javaEnabled()}
        const response = await MyAccountService.createRecurringProfile({
            recurringProfile: this.state.profile,
            ccInfo: newCCInfo,
            tokenInfo: !isNewCard ? { cvvCode: storedCard.cvvCode, permanentTokenId: storedCard.creditCardId } : undefined,
            fingerPrintSessions: FingerprintFactory.getWebSessionId(this.state.fingerPrintHelpers),
            UserBrowserInfo : browserInfo
        });
        await dialogService.hidePreloader();
        if (!response) return;
        if (response.responseCode !== 0) {
            messageDialog(response.responseMessage!, t.common("oops"));
            return;
        }
        if (response.payLoad!.redirectUrl) {
            const recurringProfileId = response.payLoad!.recurringProfileId;
            const result = await dialogService.showComponent<{ payLoad: boolean }>(ThreeDSecure, { hash: "3d", animation: "slide-down", style: { bottom: 0 } }, {
                url: response.payLoad!.redirectUrl,
                transactionId: recurringProfileId
            });
            if (result.cancelled || !result.payLoad) return;
            dialogService.showPreloader();
            const threeDResponse = await MyAccountService.continueOn3DSuccess(recurringProfileId);
            await dialogService.hidePreloader();
            if (!threeDResponse) return;
            if (threeDResponse.responseCode === 0) {
                await messageDialog(t.autoTopup("auto_balance_success"), t.menu("auto_balance"));
                this.props.history.replace("/auto-topups");
            } else {
                messageDialog(threeDResponse.responseMessage!, t.common("oops"));
            }
        } else {
            await messageDialog(t.autoTopup("auto_balance_success"), t.menu("auto_balance"));
            this.props.history.replace("/auto-topups");
        }
    }
    async componentDidMount() {
        const response = await MyAccountService.initProfile();
        if (!response) {
            this.props.history.push("/topup");
            return;
        }
        const countries = response.payLoad!.countries;
        const profile = response.payLoad!.profile;
        const deviceFingerPrintSettings = await TopupService.getFingerprintTags(this.state.sessionId, profile.sourceCurrencyCode);
        const fingerPrintHelpers = FingerprintFactory.getHelpers(deviceFingerPrintSettings.payLoad);
        const settings = await this.loadCreditCardDetails(profile.sourceCurrencyCode);
        const { storedCreditCards, paymentCountries, addressSettings, siteSettings, creditCardHelper } = settings;
        this.setState({ fingerPrintHelpers: fingerPrintHelpers });
        const query = this.props.location.query;
        const qsCountry = query.cc ? countries.find(c => c.countryCode === query.cc) : undefined;

        let selectedCountry: Country | undefined;
        let products: Product[] = [];
        let selectedProductId: number | undefined;
        let selectedSkuId: number | undefined;
        if (response.responseCode === 0) {
            if (countries.length === 1 || qsCountry) {
                selectedCountry = qsCountry || countries[0];
                const productResponse = await MyAccountService.getProducts(selectedCountry.countryCode);
                if (productResponse.responseCode === 0) {
                    products = productResponse.payLoad!.products;
                    const qsProduct = query.p ? products.find(p => p.productId === +query.p) : undefined;
                    if (products.length === 1 || qsProduct) {
                        const selectedProduct = qsProduct || products[0];
                        selectedProductId = selectedProduct.productId;
                        const selectedSku = query.a ? selectedProduct.skus.find(s => s.faceValue === +query.a) : selectedProduct.skus[0];
                        selectedSkuId = selectedSku ? selectedSku.skuId : selectedProduct.skus[0].skuId;
                    }
                }
            } else {
                selectedCountry = undefined;
            }
            this.setState({
                countries: countries, selectedCountry: selectedCountry, products: products,
                fingerPrintHelpers, storedCreditCards, paymentCountries, addressSettings, siteSettings, creditCardHelper,
                payment: {
                    ...this.state.payment,
                    creditCardMethod: storedCreditCards.length > 0 ? "stored" : "new",
                    creditCard: { ...this.state.payment.creditCard!, country: profile.locationCountry || "US" },
                    storedCard: storedCreditCards.length > 0 ? storedCreditCards[0] : undefined
                },
                profile: {
                    ...profile,
                    countryCode: selectedCountry ? selectedCountry.countryCode : "",
                    internationalCode: selectedCountry ? selectedCountry.internationalCode : undefined,
                    productId: selectedProductId,
                    skuId: selectedSkuId,
                    localMobileNumber: query.mn || ""
                }
            });
        }
    }
    renderCreditCardType() {
        if (this.state.storedCreditCards.length === 0) return null;
        const creditCardMethod = this.state.payment.creditCardMethod;
        return (
            <div className="row">
                <div className="col-6">
                    <label className={classNames({ "credit-card-method": true, selected: creditCardMethod === "stored" })}>
                        <input type="radio" name="creditCardMethod" value="stored" checked={creditCardMethod === "stored"}
                            onChange={e => this.creditCardMethodChanged("stored")}
                            style={{ visibility: "hidden", position: "absolute" }} />
                        <span>{t.topup("stored_credit_card")}</span>
                    </label>
                </div>
                <div className="col-6">
                    <label className={classNames({ "credit-card-method": true, selected: creditCardMethod === "new" })}>
                        <input type="radio" name="creditCardMethod" value="new" checked={creditCardMethod === "new"}
                            onChange={e => this.creditCardMethodChanged("new")}
                            style={{ visibility: "hidden", position: "absolute" }} />
                        <span>{t.topup("new_card_type")}</span>
                    </label>
                </div>
            </div>
        );
    }
    renderStoredCreditCard() {
        const ccPayment = this.state.payment || { creditCardMethod: "new" } as CreditCardPayment;
        if (ccPayment.creditCardMethod === "new") return null;
        const storedCard = this.state.payment.storedCard || {} as StoredCreditCard;
        const storedCards = this.state.storedCreditCards;
        return <StoredCreditCardComp
            storedCard={storedCard}
            storedCreditCards={storedCards}
            storedCreditCardChanged={this.storedCreditCardChanged}
        />
    }
    renderCreditCard() {
        const ccPayment = this.state.payment || { creditCardMethod: "new" } as CreditCardPayment;
        if (ccPayment.creditCardMethod === "stored") return null;
        return <CreditCardComp ref={c => this._creditCardComp = c}
            countries={this.state.paymentCountries}
            addressSettings={this.state.addressSettings || { usUkCa: true, others: false }}
            creditCard={this.state.payment.creditCard}
            storedCreditCards={this.state.storedCreditCards}
            creditCardChanged={this.creditCardChanged}
            showStoredCard={false}
        />
    }
    renderTopupDay() {
        let days: Array<{ label: string, value: number }>;
        if (this.state.profile.frequency === Frequency.Weekly) days = weekDays;
        else if (this.state.profile.frequency === Frequency.BiWeekly) days = biWeekDays;
        else if (this.state.profile.frequency === Frequency.Monthly) days = monthDays;
        else return null;
        return <div className="form-group col-6">
            <h5>{t.autoTopup("topup_day")}</h5>
            <select className="form-control" value={this.state.profile.topupDay} onChange={this.onTopupDayChange}>
                {days.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
            </select>
        </div>;
    }
    onCountryDropdownChanged = (isOpen: boolean) => {
        if (document.body.offsetWidth <= 576) {
            this.setState({ showFooter: !isOpen });
        }
    }
    async componentWillUnmount() {
        for (let i = 0; i < this.state.fingerPrintHelpers.length; i++) {
            this.state.fingerPrintHelpers[i].detachScript();
        }
    }
    renderSkuOption(s: Sku) {
        let shortDescription= s.shortDescription!=null?' - '+s.shortDescription:'';
        if (s.usdFaceValue) {
            return `${s.usdFaceValue} USD - ${s.faceValue} ${this.state.profile.sourceCurrencyCode}`+ shortDescription;
        } else {
            return `${s.faceValue} ${this.state.profile.sourceCurrencyCode}`+ shortDescription;
        }
    }
    render() {
        if (this.state.countries.length === 0) return <Loading />;
        const selectedProduct = this.state.products.find(p => p.productId === this.state.profile.productId);
        const disableProduct = !this.state.selectedCountry;
        const disableAmount = !this.state.profile.productId;
        return <div className="container-fluid small-gutter" style={pageWidth}>
            <div className="form-group form-title">
                <h2>{t.autoTopup("new_profile_button_title")}</h2>
            </div>
            <div className="form-group">
                <h5 id="mobile-number-label">{t.topup("mobile_number_placeholder")}</h5>
                <Number country={this.state.selectedCountry}
                    product={selectedProduct}
                    mobileNumber={this.state.profile.localMobileNumber}
                    onMobileNumberChanged={this.onMobileNumberChanged}
                    countries={this.state.countries}
                    onCountrySelected={this.onCountrySelected}
                    onDropdownChanged={this.onCountryDropdownChanged}
                    focusOnMe={true}
                />
            </div>
            <div className="row">
                <div className="form-group col-6">
                    <h5>{t.topup("select_operator")}</h5>
                    <select className="form-control" disabled={disableProduct}
                        value={this.state.profile.productId}
                        onChange={e => this.onProductSelected(+e.target.value)}>
                        {this.state.products.length > 1 && !this.state.profile.productId && <option key={-1} value={-1}>{t.topup("select_operator")}</option>}
                        {this.state.products.map(p => <option key={p.productId} value={p.productId}>{p.name}</option>)}
                    </select>
                    {(!disableProduct && !this.state.profile.productId) && <span className="fluent-invalid-feedback">{t.topup("select_operator")}</span>}
                </div>
                <div className="form-group col-6">
                    <h5>
                        <label><input type="radio" checked={!this.state.isDataPlan} name="categoty" id="rtr" value={1} onChange={(e)=>this.onCategoryChange(e)} />{t.topup("select_amt_label")}</label>
                        {selectedProduct && selectedProduct?.dataSkus.length>0 && <label><input type="radio" checked={this.state.isDataPlan} name="categoty" id="data" value={2} onChange={(e)=>this.onCategoryChange(e)} />Select Data Plan</label>}
                    </h5>
                    {/* {!this.state.isDataPlan && <select className="form-control" disabled={disableAmount} value={this.state.profile.skuId}
                        onChange={e => this.setState({ profile: { ...this.state.profile, skuId: +e.target.value } })} >
                        {selectedProduct && selectedProduct.skus.map(s =>
                            <option key={s.skuId} value={s.skuId}>
                                {this.renderSkuOption(s)}
                            </option>
                        )}
                    </select>
                    }
                   {this.state.isDataPlan && <select className="form-control" disabled={disableAmount} value={this.state.profile.skuId}
                        onChange={e => this.setState({ profile: { ...this.state.profile, skuId: +e.target.value } })} >
                        {selectedProduct && selectedProduct.dataSkus.map(s =>
                            <option key={s.skuId} value={s.skuId}>
                                {this.renderSkuOption(s)}
                            </option>
                        )}
                    </select>
                } */}
                <select className="form-control" disabled={disableAmount} value={this.state.profile.skuId}
                        onChange={e => {this.setState({ profile: { ...this.state.profile, skuId: +e.target.value } }); console.log(e.target.value)} } >
                        {selectedProduct && !this.state.isDataPlan && selectedProduct.skus.map(s =>
                            <option key={s.skuId} value={s.skuId}>
                                {this.renderSkuOption(s)}
                            </option>
                        )}
                        {selectedProduct && this.state.isDataPlan && selectedProduct.dataSkus.map(s =>
                            <option key={s.skuId} value={s.skuId}>
                                {this.renderSkuOption(s)}
                            </option>
                        )}
                    </select>
                </div>
                <div className="form-group col-6">
                    <h5>{t.autoTopup("frequency_label")}</h5>
                    {/* {!this.state.isDataPlan &&     */}
                    <select className="form-control" value={this.state.profile.frequency} onChange={this.onFrequencyChange}>
                        <option value={Frequency.Monthly}>{t.autoTopup("frequency_30days")}</option>
                        <option value={Frequency.BiWeekly}>{t.autoTopup("frequency_15days")}</option>
                        <option value={Frequency.Weekly}>{t.autoTopup("frequency_7days")}</option>
                    </select>
                {
                // this.state.isDataPlan && <select className="form-control" value={0}>
                //     <option value={0}>{'One day before end of validity'}</option>
                // </select>
                }
                </div>
                {this.renderTopupDay()}
                <div className="form-group col-6">
                    <h5>{t.autoTopup("contact_number")}</h5>
                    <MaskedInput mask={contactMask} guide={false} maxLength={15}
                            ref={this.assignMaskRef} className="form-control"
                            value={this.state.profile.contactNumber|| ""} onChange={e => this.onContactNumberChange(e.target.value)}
                        />
                </div>
                {(!disableProduct && !disableAmount) && <div className="col-12 form-group">
                    <div style={messageStyle}>
                        {this.formatMessage(this.state.profile.frequency, this.state.profile.topupDay)}
                    </div>
                </div>}
                {/* {this.state.isDataPlan && <div className="col-12 form-group">
                    <div style={messageStyle}>
                    Schedule: On the end of plan duration. Note: You can cancel auto top-up any time. No question asked.
                    You will be charged the equivalent of the USD amount based on the exchange rate on the date of the Top-up.
                    </div>
                </div>}                 */
                }
            </div>
            {this.renderCreditCardType()}
            {this.renderCreditCard()}
            {this.renderStoredCreditCard()}
            {this.state.profile.productId && <div className="form-group">
                <span>{t.autoTopup("terms_and_conditions_msg")}&nbsp;</span>
                <a target="_blank" href={`/terms-and-conditions/${this.state.profile.productId}`}>{t.autoTopup("terms_and_conditions_link")}</a>
            </div>}
            {this.state.showFooter && <Footer onButtonClick={this.submit} buttonText={t.autoTopup("enable_profile_button_title")} />}
        </div>
    }
}
const pageWidth: React.CSSProperties = {
    maxWidth: 768,
    width: "100%",
}
const messageStyle: React.CSSProperties = {
    padding: "0.375rem 0.75rem",
    color: "#495057",
    backgroundColor: "#fff",
    border: "1px solid #ced4da",
    borderRadius: 3,
}
const creditCardDev: CreditCard = isDev ? {
    creditCardNumber: "4111111111111111",
    expiryMonthyear: "12/23",
    cvvCode: "123",
    lastName: "Jane Doe",
    streetAddress: "123 Freedom dr.",
    state: "IL",
    city: "Oswigo",
    zipCode: "12345",
    storeCc: false,
} as CreditCard : {} as CreditCard
